import { PlacementStates, ProjectCancellation } from '../../../../services/project-service.types';
import { getWorkApplicationCancelationReason } from '../../../../utils/cancelation-reasons';

const stateMessages: { [key in PlacementStates]?: string } = {
  // t('status.cancelled')
  canceled: 'status.cancelled',
  // t('status.terminated')
  terminated: 'status.terminated',
  // t('status.completed')
  completed: 'status.completed',
};

const isWork = (input: ProjectCancellation): boolean => {
  return input.relation.relation === 'placement';
};

const isWorkApplication = (input: ProjectCancellation): boolean => {
  return input.relation.relation === 'workApplication';
};

const getProjectCancelationReason = (input: ProjectCancellation): string => {
  let cancelationReason: string | undefined = undefined;
  if (isWork(input)) {
    cancelationReason = stateMessages[input.state];
  } else if (isWorkApplication(input)) {
    cancelationReason = getWorkApplicationCancelationReason(input.cancellationReason ?? 'unknown');
  }

  // t('status.unknown')
  return cancelationReason ?? 'status.unknown';
};

export { getProjectCancelationReason as getProjectCancelationReason };
